import { render, staticRenderFns } from "./HrBasicOrgHis.vue?vue&type=template&id=0208931e&scoped=true&"
import script from "./HrBasicOrgHis.vue?vue&type=script&lang=js&"
export * from "./HrBasicOrgHis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0208931e",
  null
  
)

export default component.exports